<template>
  <div>
    <b-container fluid style="min-height: calc(40vh)" class="px-0">
      <b-card id="card-principal" class="mb-0 pb-0">
        <template #header>
          <i class="fas fa-edit"></i>
          <strong>{{$lang.PCI.PDR.ApprovalTitle}}</strong>
        </template>
        <div>
          <ag-grid-vue style="width: 100%; height: calc(65vh)" id="obras-grid"
                       class="ag-theme-alpine"
                       :rowMultiSelectWithClick="false"
                       rowSelection="single"
                       :getLocaleText="localeTextFunc"
                       :gridOptions="obrasDataGridOptions"
                       :columnTypes="columnTypes"
                       :columnDefs="obrasColumnDefs"
                       :rowData="obrasRowData"
                       :headerHeight="45"
                       :rowHeight="30"
                       @cellDoubleClicked="viewForm"
                       @filterChanged="onFilterChange"
                       @gridReady="onGridReady">
          </ag-grid-vue>
        </div>
        <b-row style="display: flow-root;">
          <b-col cols="1">
            <span style="font-size: small;font-weight: bold;">Total: </span>
            {{ totalWorkRows }}
          </b-col>
        </b-row>
      </b-card>
    </b-container>

    <!-- Formulário -->
    <b-modal
      v-model="showForm"
      ref="modal"
      size="xl"
      centered
      :hide-footer="true"
    >
      <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{ $lang.PCI.PDR.ApprovalFormTitle }}
          </span>
          <button class="close" @click="onHide">x</button>
        </div>
      </template>
      <div v-if="showForm" class="d-flex flex-column justify-content-start">
        <b-row>
          <b-col cols="12" lg="6">
            <b-row>
              <b-col cols="12" lg="6" class="pr-lg-0 mt-1">
                <span>Contrato</span>
                <b-input disabled v-model="formCheckList.contrato"></b-input>
              </b-col>
              <b-col cols="6" sm="6" lg="3" class="pr-0 mt-1">
                <span>Obra</span>
                <b-input disabled v-model="formCheckList.obra"></b-input>
              </b-col>
              <b-col cols="6" sm="6" lg="3" class="mt-1">
                <span>ID Site</span>
                <b-input disabled v-model="formCheckList.idSite"></b-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="0" lg="1"></b-col>
          <b-col cols="12" lg="5">
            <b-row>
              <b-col cols="6" lg="3" class="pr-0 mt-1">
                <span>Início</span>
                <b-input disabled v-model="formCheckList.inicioObra"></b-input>
              </b-col>
              <b-col cols="6" lg="3" class="pr-lg-0 mt-1">
                <span>Término</span>
                <b-input disabled v-model="formCheckList.terminoObra"></b-input>
              </b-col>
              <b-col cols="4" lg="2" class="pr-0 mt-1">
                <span>Prazo</span>
                <b-input type="number" disabled v-model="formCheckList.prazoObra"></b-input>
              </b-col>
              <b-col cols="4" lg="2" class="pr-0 mt-1">
                <span>Parados</span>
                <b-input type="number" disabled v-model="formCheckList.diasParados"></b-input>
              </b-col>
              <b-col cols="4" lg="2" class="mt-1">
                <span>Real</span>
                <b-input type="number" disabled v-model="realTerm"></b-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6">
            <b-row>
              <b-col cols="6" lg="4" class="pr-0 mt-1">
                <span>Tipo</span>
                <b-input disabled v-model="formCheckList.tipoBonificacao"></b-input>
              </b-col>
              <b-col cols="6" lg="3" class="pr-lg-0 mt-1">
                <span>Valor</span>
                <b-input type="text" disabled v-model="formCheckList.valor" class="text-right"></b-input>
              </b-col>
              <b-col cols="12" lg="5" class="mt-1">
                <span>Responsável</span>
                <b-input disabled v-model="formCheckList.responsavelCheckList"></b-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="6">
            <b-row>
              <b-col cols="3" class="d-flex flex-column-reverse mt-1">
                <b-form-input disabled v-model="formCheckList.checkAtAntesTermObra" />
                <span>AT antes inicio. obra</span>
              </b-col>
              <b-col cols="3" class="d-flex flex-column-reverse pl-0 mt-1">
                <b-form-input disabled v-model="formCheckList.checkDocComplTerm" />
                <span>Doc. compl. term.</span>
              </b-col>
              <b-col cols="3" class="d-flex flex-column-reverse pl-0 mt-1">
                <b-form-input disabled v-model="formCheckList.checkPo" />
                <span>PO</span>
              </b-col>
              <b-col cols="3" class="d-flex flex-column-reverse pl-0 mt-1">
                <b-form-input disabled type="number" v-model="formCheckList.percFat" />
                <span>FAT.%</span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-1"><span>Observação</span></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-textarea disabled v-model="formCheckList.observacao" :max-rows="20"></b-textarea>
          </b-col>
        </b-row>
        <b-row class="row justify-content-end pr-3 pt-2">
          <i class="fas fa-print text-third pointer"
            style="font-size: 2em;"
            v-b-tooltip.hover :title="$lang.PCI.PDR.PrintHover"
            v-show="workMemberID"
            v-on:click="generatePDF()">
          </i>
          <i class="fas fa-print pointer"
            style="font-size: 2em;"
            v-b-tooltip.hover :title="$lang.PCI.PDR.SelectMemberHover"
            v-show="!workMemberID">
          </i>
        </b-row>
        <div class="d-flex flex-direction-column flex-grow-1">
          <ag-grid-vue id="obras-grid"
                        class="ag-theme-alpine w-100 h-100"
                        domLayout='autoHeight'
                        :rowMultiSelectWithClick="false"
                        :getLocaleText="localeTextFunc"
                        :gridOptions="membersGridOptions"
                        :columnTypes="columnTypes"
                        :columnDefs="membersColumnDefs"
                        :rowData="formCheckList.membros"
                        :headerHeight="30"
                        :rowHeight="30"
                        @cellDoubleClicked="generatePDF"
                        @cellFocused="setWorkMember"
                        @gridReady="onGridReady">
          </ag-grid-vue>
        </div>
        <div id="div-buttons" class="mt-4">
          <button v-if="hasRole(roles.RW_OPER_PCI_PDR_TECNICAL)" type="button" class="btn btn-third btn-sm" v-on:click="approveForm" v-b-tooltip.hover><i class="fa fa-check"></i> Aprovar</button>
          <button v-if="hasRole(roles.RW_OPER_PCI_PDR_TECNICAL)" type="button" title="Rejeição Diretor Técnico" class="btn btn-danger btn-sm" v-on:click="disapproveForm" v-b-tooltip.hover><i class="fa fa-ban"></i> Reprovar</button>
          <button v-if="hasRole(roles.RW_OPER_PCI_PDR_ENGINEERING)" type="button" title="Rejeição Gerente Engenharia" class="btn btn-danger btn-sm" v-on:click="disapproveEngManagerForm" v-b-tooltip.hover><i class="fa fa-ban"></i> Reprovar</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import pdrbonusapproval from './pdrbonusapproval.js'
export default pdrbonusapproval
</script>

<style scoped>
  #div-buttons {
    margin-top: 20px;
    text-align: right;
  }

  * >>> .low-note {
    color: red;
    font-weight: bolder;
  }

  * >>> .ag-header-cell {
    background-color: #008144;
    font-size: 1rem;
  }

  .formularioAvaliacaoTitulo span {
    font-weight: bold;
  }
  * >>> .modal-header {
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
  }
  * >>> .modal-body {
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    scroll-snap-type: y proximity;
  }
  * >>> .modal-footer {
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
  }
  * >>> .modal-content {
    border-radius: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/pdrbonusapproval/pdrbonusapproval.vue